'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { ChevronRight, ChevronLeft, Wrench, Search } from 'lucide-react';

// Brand logo SVG components
const AppleLogo = () => (
  <svg viewBox="0 0 814 1000" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="currentColor">
    <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.7 0 663 0 541.8c0-207.5 135.4-317.3 269-317.3 70.1 0 128.4 46.4 172.5 46.4 42.8 0 109.6-49 192.5-49 31 0 108.2 2.6 168.6 71.9zm-174.5-186.5c31.7-37.5 54.3-89.7 54.3-141.9 0-7.1-.6-14.3-1.9-20.1-51.6 2-112 34.4-148.4 75.8-28.5 32.4-55.1 84.7-55.1 137.6 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 46.4 0 102.9-31.1 135.6-70.8z"/>
  </svg>
);

const SamsungLogo = () => (
  <svg viewBox="0 0 300 60" xmlns="http://www.w3.org/2000/svg" className="w-24 h-10" fill="currentColor">
    <path d="M18.6 14.4c-4.2 0-7.6 1.4-9.8 3.9-1.8 2-2.7 4.6-2.7 7.5 0 5.4 2.8 8.8 9.3 11.1l4.2 1.5c4.2 1.5 5.8 3 5.8 5.6 0 2.9-2.3 4.8-5.9 4.8-4.1 0-7-2.2-7.3-5.6H6.1c.4 6.5 5.3 10.4 12.2 10.4 7.4 0 12.3-4.1 12.3-10.3 0-5.5-2.9-8.8-9.9-11.3l-4-1.4c-3.8-1.4-5.4-2.8-5.4-5.3 0-2.5 2-4.2 5.2-4.2 3.5 0 5.8 1.9 6.1 5h6c-.5-6-5-10.7-11.9-10.7zM50.4 15l-8.7 37.6h6.3l1.8-8.5h9.6l1.8 8.5h6.4L58.9 15H50.4zm4.3 5.5l3.7 18.5h-7.5l3.8-18.5zM100.3 15l-7.1 27.5L86.1 15h-8.7v37.6h5.9V21.8l7.7 30.8h5.4l7.7-30.8v30.8h5.9V15h-9.7zM133.1 15l-8.7 37.6h6.3l1.8-8.5h9.6l1.8 8.5h6.4L141.6 15h-8.5zm4.3 5.5l3.7 18.5h-7.5l3.8-18.5zM175.5 15v27.2L162.8 15h-7.6v37.6h5.9V25.3l12.9 27.3h7.4V15h-5.9zM207.5 33.4h8.7v11.3c-1.4.9-3.5 1.5-5.8 1.5-6.3 0-10.1-4.4-10.1-11.9 0-7.3 3.9-11.9 10.2-11.9 3.8 0 6.4 1.5 8 4.5l5.3-2.8c-2.4-4.8-7-7.7-13.3-7.7-9.9 0-16.7 6.8-16.7 17.9 0 11.2 6.7 17.9 16.5 17.9 5.2 0 9.8-1.7 13.2-4.7V28.5h-16v4.9zM244.8 14.4c-4.2 0-7.6 1.4-9.8 3.9-1.8 2-2.7 4.6-2.7 7.5 0 5.4 2.8 8.8 9.3 11.1l4.2 1.5c4.2 1.5 5.8 3 5.8 5.6 0 2.9-2.3 4.8-5.9 4.8-4.1 0-7-2.2-7.3-5.6h-6.1c.4 6.5 5.3 10.4 12.2 10.4 7.4 0 12.3-4.1 12.3-10.3 0-5.5-2.9-8.8-9.9-11.3l-4-1.4c-3.8-1.4-5.4-2.8-5.4-5.3 0-2.5 2-4.2 5.2-4.2 3.5 0 5.8 1.9 6.1 5h6c-.5-6-5-10.7-11.9-10.7z"/>
  </svg>
);

const GoogleLogo = () => (
  <svg viewBox="0 0 272 92" xmlns="http://www.w3.org/2000/svg" className="w-24 h-10">
    <path d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z" fill="#EA4335"/>
    <path d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z" fill="#FBBC05"/>
    <path d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z" fill="#4285F4"/>
    <path d="M225 3v65h-9.5V3h9.5z" fill="#34A853"/>
    <path d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z" fill="#EA4335"/>
    <path d="M35.29 41.41V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49.01z" fill="#4285F4"/>
  </svg>
);

const repairData: Record<string, Record<string, Record<string, number | null>>> = {
  Apple: {
    'iPhone 11': { 'Screen Replacement': 149, 'Battery Replacement': 79, 'Back Glass Replacement': 129, 'Charging Port Replacement': 89, 'Rear Camera Replacement': 119, 'Front Camera Replacement': 99, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 199 },
    'iPhone 12': { 'Screen Replacement': 169, 'Battery Replacement': 89, 'Back Glass Replacement': 149, 'Charging Port Replacement': 95, 'Rear Camera Replacement': 129, 'Front Camera Replacement': 109, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 219 },
    'iPhone 13': { 'Screen Replacement': 189, 'Battery Replacement': 99, 'Back Glass Replacement': 169, 'Charging Port Replacement': 99, 'Rear Camera Replacement': 139, 'Front Camera Replacement': 119, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 239 },
    'iPhone 14': { 'Screen Replacement': 199, 'Battery Replacement': 109, 'Back Glass Replacement': 179, 'Charging Port Replacement': 109, 'Rear Camera Replacement': 149, 'Front Camera Replacement': 129, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 259 },
    'iPhone 15': { 'Screen Replacement': 219, 'Battery Replacement': 119, 'Back Glass Replacement': 199, 'Charging Port Replacement': 119, 'Rear Camera Replacement': 169, 'Front Camera Replacement': 139, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 279 },
    'iPhone 16': { 'Screen Replacement': 239, 'Battery Replacement': 129, 'Back Glass Replacement': 219, 'Charging Port Replacement': 129, 'Rear Camera Replacement': 189, 'Front Camera Replacement': 149, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 299 },
    'iPhone 17': { 'Screen Replacement': 259, 'Battery Replacement': 139, 'Back Glass Replacement': 239, 'Charging Port Replacement': 139, 'Rear Camera Replacement': 209, 'Front Camera Replacement': 159, 'Camera Lens Replacement (per lens)': 30, 'Housing Replacement': 319 },
  },
  Samsung: {},
  Google: {},
};

const brands = [
  { id: 'brand-apple', name: 'Apple', available: true, LogoComponent: AppleLogo },
  { id: 'brand-samsung', name: 'Samsung', available: false, LogoComponent: SamsungLogo },
  { id: 'brand-google', name: 'Google', available: false, LogoComponent: GoogleLogo },
];

type Step = 1 | 2 | 3;

export default function RepairPriceFinder() {
  const [step, setStep] = useState<Step>(1);
  const [selectedBrand, setSelectedBrand] = useState<string>('');
  const [selectedModel, setSelectedModel] = useState<string>('');
  const [modelSearch, setModelSearch] = useState('');

  const models = selectedBrand ? Object.keys(repairData[selectedBrand] || {}) : [];
  const filteredModels = models.filter((m) =>
    m.toLowerCase().includes(modelSearch.toLowerCase())
  );
  const repairs = selectedBrand && selectedModel
    ? repairData[selectedBrand]?.[selectedModel] || {}
    : {};

  const handleBrandSelect = (brand: string) => {
    setSelectedBrand(brand);
    setSelectedModel('');
    setModelSearch('');
    setStep(2);
  };

  const handleModelSelect = (model: string) => {
    setSelectedModel(model);
    setStep(3);
  };

  const handleReset = () => {
    setStep(1);
    setSelectedBrand('');
    setSelectedModel('');
    setModelSearch('');
  };

  const bookingUrl = `/repairs?brand=${encodeURIComponent(selectedBrand)}&model=${encodeURIComponent(selectedModel)}`;

  return (
    <section className="px-6 py-12 lg:px-10 lg:py-16" style={{ backgroundColor: '#0a0a0a' }}>
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <h2 className="section-title">
              Repair <span style={{ color: '#d4a843' }}>Price Finder</span>
            </h2>
            <p className="mt-2 text-sm md:text-base" style={{ color: '#8a7a65' }}>Select your device to instantly view repair prices. No hidden fees.</p>
          </div>
          <Link
            href="/repairs"
            className="font-bold text-sm flex items-center gap-1.5 transition-colors"
            style={{ color: '#d4a843' }}
          >
            All Repairs <ChevronRight size={16} />
          </Link>
        </div>

        {/* Step indicator */}
        <div className="flex items-center justify-center gap-2 mb-10">
          {([1, 2, 3] as Step[]).map((s, idx) => (
            <React.Fragment key={`step-indicator-${s}`}>
              <div className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-200 ${
                    step === s ? '' : step > s ? 'step-complete' : 'step-inactive'
                  }`}
                  style={step === s ? { backgroundColor: '#d4a843', color: '#0a0a0a' } : {}}
                >
                  {step > s ? '✓' : s}
                </div>
                <span className="text-sm font-medium hidden sm:block" style={{ color: step >= s ? '#f5f0e8' : '#5a4a35' }}>
                  {s === 1 ? 'Select Brand' : s === 2 ? 'Select Model' : 'View Prices'}
                </span>
              </div>
              {idx < 2 && (
                <div
                  className="w-12 sm:w-20 h-0.5 rounded-full transition-colors duration-200"
                  style={{ backgroundColor: step > s ? '#d4a843' : '#2a2a2a' }}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="max-w-3xl mx-auto">
          <div
            className="p-6 sm:p-8"
            style={{ borderRadius: 'var(--bubbly-radius)', boxShadow: 'var(--card-shadow)', backgroundColor: '#111111', border: '1px solid #2a2a2a' }}
          >
            {/* Step 1: Brand */}
            {step === 1 && (
              <div className="animate-slide-up">
                <h3 className="text-lg font-extrabold mb-6 text-center" style={{ color: '#f5f0e8' }}>Select your brand</h3>
                <div className="grid grid-cols-3 gap-4">
                  {brands.map((brand) => (
                    <button
                      key={brand.id}
                      onClick={() => brand.available && handleBrandSelect(brand.name)}
                      disabled={!brand.available}
                      className={`relative flex flex-col items-center gap-3 p-6 rounded-2xl transition-all duration-150 ${
                        brand.available ? 'cursor-pointer active:scale-95' : 'opacity-40 cursor-not-allowed'
                      }`}
                      style={{
                        border: '2px solid #2a2a2a',
                        backgroundColor: '#0d0d0d',
                      }}
                      onMouseEnter={e => brand.available && ((e.currentTarget as HTMLElement).style.borderColor = '#d4a843')}
                      onMouseLeave={e => ((e.currentTarget as HTMLElement).style.borderColor = '#2a2a2a')}
                    >
                      <span className="flex items-center justify-center h-10" style={{ color: '#f5f0e8' }}>
                        <brand.LogoComponent />
                      </span>
                      <span className="font-bold text-sm" style={{ color: '#f5f0e8' }}>{brand.name}</span>
                      {!brand.available && (
                        <span className="absolute top-2 right-2 text-xs px-2 py-0.5 rounded-full font-medium" style={{ backgroundColor: '#1a1a1a', color: '#5a4a35' }}>Soon</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Step 2: Model */}
            {step === 2 && (
              <div className="animate-slide-up">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-extrabold" style={{ color: '#f5f0e8' }}>Select your {selectedBrand} model</h3>
                  <button
                    onClick={() => setStep(1)}
                    className="flex items-center gap-1 text-sm font-semibold transition-colors"
                    style={{ color: '#8a7a65' }}
                  >
                    <ChevronLeft size={14} />
                    Back
                  </button>
                </div>

                <div className="relative mb-5">
                  <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2" style={{ color: '#5a4a35' }} />
                  <input
                    type="text"
                    placeholder="Search models..."
                    value={modelSearch}
                    onChange={(e) => setModelSearch(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 rounded-xl text-sm"
                    style={{ backgroundColor: '#0d0d0d', border: '1px solid #2a2a2a', color: '#f5f0e8' }}
                  />
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5 max-h-80 overflow-y-auto pr-1">
                  {filteredModels.map((model) => (
                    <button
                      key={`model-${model}`}
                      onClick={() => handleModelSelect(model)}
                      className="text-left px-4 py-3 rounded-2xl transition-all duration-150 text-sm font-semibold active:scale-95"
                      style={{ border: '1px solid #2a2a2a', backgroundColor: '#0d0d0d', color: '#f5f0e8' }}
                      onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#d4a843'; (e.currentTarget as HTMLElement).style.backgroundColor = 'rgba(212,168,67,0.05)'; }}
                      onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#2a2a2a'; (e.currentTarget as HTMLElement).style.backgroundColor = '#0d0d0d'; }}
                    >
                      {model}
                    </button>
                  ))}
                  {filteredModels.length === 0 && (
                    <div className="col-span-3 text-center py-8 text-sm" style={{ color: '#5a4a35' }}>
                      No models found for &quot;{modelSearch}&quot;
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Step 3: Prices */}
            {step === 3 && (
              <div className="animate-slide-up">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h3 className="text-lg font-extrabold" style={{ color: '#f5f0e8' }}>{selectedModel} Repairs</h3>
                    <p className="text-sm mt-0.5" style={{ color: '#8a7a65' }}>All prices in AUD. Includes labour and parts.</p>
                  </div>
                  <button
                    onClick={() => setStep(2)}
                    className="flex items-center gap-1 text-sm font-semibold transition-colors"
                    style={{ color: '#8a7a65' }}
                  >
                    <ChevronLeft size={14} />
                    Back
                  </button>
                </div>

                <div className="rounded-2xl overflow-hidden" style={{ border: '1px solid #2a2a2a' }}>
                  <table className="w-full">
                    <thead>
                      <tr style={{ backgroundColor: '#0d0d0d', borderBottom: '1px solid #2a2a2a' }}>
                        <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wide" style={{ color: '#5a4a35' }}>Repair Type</th>
                        <th className="text-right px-4 py-3 text-xs font-bold uppercase tracking-wide" style={{ color: '#5a4a35' }}>Price</th>
                        <th className="text-right px-4 py-3 text-xs font-bold uppercase tracking-wide hidden sm:table-cell" style={{ color: '#5a4a35' }}>Book</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(repairs).map(([repairType, price], idx) => (
                        <tr key={`repair-row-${repairType}`} style={{ borderTop: idx > 0 ? '1px solid #1a1a1a' : 'none' }}>
                          <td className="px-4 py-3.5 text-sm font-semibold" style={{ color: '#f5f0e8' }}>
                            <div className="flex items-center gap-2">
                              <Wrench size={14} style={{ color: '#5a4a35' }} className="flex-shrink-0" />
                              {repairType}
                            </div>
                          </td>
                          <td className="px-4 py-3.5 text-right">
                            {price !== null ? (
                              <span className="text-sm font-extrabold price-tag" style={{ color: '#d4a843' }}>${price}</span>
                            ) : (
                              <span className="text-xs" style={{ color: '#5a4a35' }}>POA</span>
                            )}
                          </td>
                          <td className="px-4 py-3.5 text-right hidden sm:table-cell">
                            <Link
                              href={`${bookingUrl}&repair=${encodeURIComponent(repairType)}`}
                              className="inline-flex items-center gap-1 text-xs font-bold transition-colors"
                              style={{ color: '#d4a843' }}
                            >
                              Book
                              <ChevronRight size={12} />
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="mt-5 flex flex-col sm:flex-row gap-3">
                  <Link
                    href={bookingUrl}
                    className="flex-1 flex items-center justify-center gap-2 rounded-full h-12 font-bold text-sm transition-all hover:scale-[1.02]"
                    style={{ backgroundColor: '#d4a843', color: '#0a0a0a', boxShadow: '0 4px 16px 0 rgba(212,168,67,0.3)' }}
                  >
                    <Wrench size={16} />
                    Book a Repair for {selectedModel}
                  </Link>
                  <button
                    onClick={handleReset}
                    className="flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold transition-colors"
                    style={{ border: '1px solid #2a2a2a', backgroundColor: '#1a1a1a', color: '#f5f0e8' }}
                  >
                    Check Another Device
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}